module.exports = __webpack_public_path__ + "media/images/emblems/Cologny-coat_of_arms-fdd6f5248163b20ec38c8df87684cd42.svg";